"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withoutItemsNavigation = exports.withTabsNavigation = exports.withLoadingNavigation = exports.withFocusTabsNavigation = exports.withIframeNavigation = exports.withFocusNavigation = exports.withEmptyNavigation = exports.withDefaultSiteSelectorNavigation = exports.withDefaultNavigation = exports.withCustomFocusNavigation = exports.withBusinessSelectorNavigation = exports.withEmptySiteSelectorNavigation = exports.withShellFocusNavigation = exports.withShellDefaultNavigation = exports.withShellEmptyNavigation = void 0;

var _react = _interopRequireWildcard(require("react"));

var _CircularProgress = _interopRequireDefault(require("@eig-builder/core-ui/CircularProgress"));

var _defaultSiteselectorNavigation = _interopRequireDefault(require("./default-siteselector-navigation"));

var _customFocusNavigation = _interopRequireDefault(require("./custom-focus-navigation"));

var _defaultNavigation = _interopRequireDefault(require("./default-navigation"));

var _emptyNavigation = _interopRequireDefault(require("./empty-navigation"));

var _emptySiteSelectorNavigation = _interopRequireDefault(require("./empty-site-selector-navigation"));

var _focusNavigation = _interopRequireDefault(require("./focus-navigation"));

var _focusTabsNavigation = _interopRequireDefault(require("./focus-tabs-navigation"));

var _iframeNavigation = _interopRequireDefault(require("./iframe-navigation"));

var _loadingNavigation = _interopRequireDefault(require("./loading-navigation"));

var _withoutItemsNavigation = _interopRequireDefault(require("./without-items-navigation"));

var _tabsNavigation = _interopRequireDefault(require("./tabs-navigation"));

var _businessSelectorNavigation = _interopRequireDefault(require("./business-selector-navigation"));

var _useResponsiveQuery = require("@eig-builder/core-utils/hooks/useResponsiveQuery");

var withNavigation = function withNavigation(NavigationComponent) {
  return function (Comp) {
    var LazyComp = _react["default"].lazy(Comp);

    return function () {
      return /*#__PURE__*/_react["default"].createElement(NavigationComponent, null, /*#__PURE__*/_react["default"].createElement(_react.Suspense, {
        fallback: /*#__PURE__*/_react["default"].createElement(_CircularProgress["default"], {
          centered: true,
          withPadding: true
        })
      }, /*#__PURE__*/_react["default"].createElement(LazyComp, null)));
    };
  };
};

var WithShellFocusNavigation = function WithShellFocusNavigation(Comp, options) {
  var LazyComp = _react["default"].lazy(Comp);

  return function () {
    // eslint-disable-next-line
    _react["default"].useEffect(function () {
      window.navigationState.header.next(options); // make focus view

      window.navigationState.drawer.next(false);
    }, []);

    return /*#__PURE__*/_react["default"].createElement(_react.Suspense, {
      fallback: /*#__PURE__*/_react["default"].createElement(_CircularProgress["default"], {
        centered: true,
        withPadding: true
      })
    }, /*#__PURE__*/_react["default"].createElement(LazyComp, null));
  };
};

var WithShellEmptyNavigation = function WithShellEmptyNavigation(Comp) {
  var LazyComp = _react["default"].lazy(Comp);

  return function () {
    // eslint-disable-next-line
    _react["default"].useEffect(function () {
      window.navigationState.drawer.next(false);
      window.navigationState.header.next(false);
    }, []);

    return /*#__PURE__*/_react["default"].createElement(_react.Suspense, {
      fallback: /*#__PURE__*/_react["default"].createElement(_CircularProgress["default"], {
        centered: true,
        withPadding: true
      })
    }, /*#__PURE__*/_react["default"].createElement(LazyComp, null));
  };
};

var WithShellDefaultNavigation = function WithShellDefaultNavigation(Comp) {
  var LazyComp = _react["default"].lazy(Comp);

  return function () {
    // eslint-disable-next-line
    var isMobile = (0, _useResponsiveQuery.useIsMobile)(); // eslint-disable-next-line

    _react["default"].useEffect(function () {
      if (!isMobile) {
        window.navigationState.drawer.next(true);
      }

      window.navigationState.header.next(true);
    }, [isMobile]);

    return /*#__PURE__*/_react["default"].createElement(_react.Suspense, {
      fallback: /*#__PURE__*/_react["default"].createElement(_CircularProgress["default"], {
        centered: true,
        withPadding: true
      })
    }, /*#__PURE__*/_react["default"].createElement(LazyComp, null));
  };
};

var withShellEmptyNavigation = WithShellEmptyNavigation;
exports.withShellEmptyNavigation = withShellEmptyNavigation;
var withShellDefaultNavigation = WithShellDefaultNavigation;
exports.withShellDefaultNavigation = withShellDefaultNavigation;
var withShellFocusNavigation = WithShellFocusNavigation;
exports.withShellFocusNavigation = withShellFocusNavigation;
var withEmptySiteSelectorNavigation = withNavigation(_emptySiteSelectorNavigation["default"]);
exports.withEmptySiteSelectorNavigation = withEmptySiteSelectorNavigation;
var withBusinessSelectorNavigation = withNavigation(_businessSelectorNavigation["default"]); // BROKEN in shell

exports.withBusinessSelectorNavigation = withBusinessSelectorNavigation;
var withCustomFocusNavigation = withNavigation(_customFocusNavigation["default"]); // Covered

exports.withCustomFocusNavigation = withCustomFocusNavigation;
var withDefaultNavigation = withNavigation(_defaultNavigation["default"]);
exports.withDefaultNavigation = withDefaultNavigation;
var withDefaultSiteSelectorNavigation = withNavigation(_defaultSiteselectorNavigation["default"]);
exports.withDefaultSiteSelectorNavigation = withDefaultSiteSelectorNavigation;
var withEmptyNavigation = withNavigation(_emptyNavigation["default"]);
exports.withEmptyNavigation = withEmptyNavigation;
var withFocusNavigation = withNavigation(_focusNavigation["default"]); // DEPRICATED

exports.withFocusNavigation = withFocusNavigation;
var withIframeNavigation = withNavigation(_iframeNavigation["default"]);
exports.withIframeNavigation = withIframeNavigation;
var withFocusTabsNavigation = withNavigation(_focusTabsNavigation["default"]);
exports.withFocusTabsNavigation = withFocusTabsNavigation;
var withLoadingNavigation = withNavigation(_loadingNavigation["default"]);
exports.withLoadingNavigation = withLoadingNavigation;
var withTabsNavigation = withNavigation(_tabsNavigation["default"]);
exports.withTabsNavigation = withTabsNavigation;
var withoutItemsNavigation = withNavigation(_withoutItemsNavigation["default"]);
exports.withoutItemsNavigation = withoutItemsNavigation;